import { useEffect } from "react";

export const useHandleKeyboardShow = () => {
  useEffect(() => {
    const handleKeyboardWillShow = () => {
      window.scrollTo(0, 0); // 스크롤 위치를 상단으로 이동
    };
    window.addEventListener("keyboardWillShow", handleKeyboardWillShow);

    return () => {
      window.removeEventListener("keyboardWillShow", handleKeyboardWillShow);
    };
  }, []);
};
